(function () {
  'use strict';

  var moneyFmt = null;
  function fmtMoney(cents) {
    if (cents === null || cents === undefined) return '';
    if (!moneyFmt) {
      try {
        moneyFmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
      } catch (e) {
        moneyFmt = { format: function (n) { return '€ ' + n.toFixed(2).replace('.', ','); } };
      }
    }
    return moneyFmt.format(cents / 100);
  }

  // ---- Tab activation (PDP) ---------------------------------
  function activateTab(tabsRoot, paneId) {
    if (!tabsRoot || !paneId) return;
    var tabs = tabsRoot.querySelectorAll('[role="tab"]');
    var panes = tabsRoot.querySelectorAll('[role="tabpanel"]');
    tabs.forEach(function (t) {
      var match = t.dataset.tab === paneId;
      t.setAttribute('aria-selected', match ? 'true' : 'false');
      t.tabIndex = match ? 0 : -1;
      t.classList.toggle('on', match);
    });
    panes.forEach(function (p) {
      var match = p.dataset.pane === paneId;
      p.classList.toggle('on', match);
      if (match) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
  }

  // ---- Variant resolution (PDP) ------------------------------
  function getSelectedVariantValues(form) {
    var groups = form.querySelectorAll('.bk-pdp-variants[data-option-position]');
    var values = [];
    groups.forEach(function (g) {
      var idx = parseInt(g.dataset.optionPosition, 10) - 1;
      var selected = g.querySelector('.opt.on');
      values[idx] = selected ? selected.dataset.value : null;
    });
    return values;
  }

  function resolveVariant(form) {
    var holder = form.parentElement.querySelector('[data-bk-product-variants]');
    if (!holder) return null;
    var variants;
    try { variants = JSON.parse(holder.textContent); } catch (e) { return null; }
    var selected = getSelectedVariantValues(form);
    return variants.find(function (v) {
      if (selected[0] != null && v.option1 !== selected[0]) return false;
      if (selected[1] != null && v.option2 !== selected[1]) return false;
      if (selected[2] != null && v.option3 !== selected[2]) return false;
      return true;
    }) || null;
  }

  function updateFormForVariant(form, variant) {
    var idInput = form.querySelector('[data-bk-variant-id]');
    var addBtn = form.querySelector('[data-bk-add]');
    var addLabel = form.querySelector('[data-bk-add-label]');
    var defaultLabel = form.dataset.ctaLabel || (addLabel ? addLabel.textContent.trim() : 'In winkelwagen');
    if (!form.dataset.ctaLabel && addLabel) form.dataset.ctaLabel = addLabel.textContent.trim();

    var stockEl = form.parentElement.querySelector('[data-bk-stock]');
    var priceEl = form.parentElement.querySelector('.price');
    var wasEl = form.parentElement.querySelector('.was');
    var badgeEl = form.parentElement.querySelector('.discount-badge');
    var savingsEl = form.parentElement.querySelector('.bk-pdp-savings');

    if (!variant) {
      if (idInput) idInput.value = '';
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Combinatie niet beschikbaar';
      if (stockEl) {
        stockEl.classList.remove('stock--in');
        stockEl.classList.add('stock--out');
        stockEl.textContent = 'Combinatie niet beschikbaar';
      }
      if (wasEl) wasEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
      if (savingsEl) savingsEl.style.display = 'none';
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? defaultLabel : 'Tijdelijk uitverkocht';
    if (stockEl) {
      if (variant.available) {
        stockEl.classList.add('stock--in');
        stockEl.classList.remove('stock--out');
        stockEl.textContent = 'Op voorraad · voor 16:00 besteld, morgen verzonden';
      } else {
        stockEl.classList.remove('stock--in');
        stockEl.classList.add('stock--out');
        stockEl.textContent = 'Tijdelijk uitverkocht';
      }
    }
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = fmtMoney(variant.price);
    }
    var onSale = typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price;
    var pct = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
    if (wasEl) {
      if (onSale) {
        wasEl.textContent = fmtMoney(variant.compare_at_price);
        wasEl.style.display = '';
      } else {
        wasEl.style.display = 'none';
      }
    }
    if (badgeEl) {
      if (onSale) {
        badgeEl.textContent = '−' + pct + '%';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
    if (savingsEl) {
      if (onSale) {
        savingsEl.innerHTML = 'U bespaart <b>' + fmtMoney(variant.compare_at_price - variant.price) + '</b> (' + pct + '%)';
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }
  }

  // ---- Cart line update via Shopify cart/change.js -----------
  var cartDebounce = null;
  function updateCartLine(key, qty, row) {
    if (cartDebounce) clearTimeout(cartDebounce);
    cartDebounce = setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || typeof cart.item_count === 'undefined') return;
          // If a line was removed, reload to reflect the empty/updated state cleanly.
          if (qty === 0) { window.location.reload(); return; }
          // Update subtotal & total
          var sub = document.querySelector('[data-bk-cart-subtotal]');
          var tot = document.querySelector('[data-bk-cart-total]');
          if (sub) sub.textContent = fmtMoney(cart.items_subtotal_price);
          if (tot) tot.textContent = fmtMoney(cart.total_price);
          // Update the line price for this row
          if (row) {
            var line = cart.items.find(function (i) { return i.key === key; });
            if (line) {
              var lp = row.querySelector('.line-price');
              if (lp) lp.textContent = fmtMoney(line.final_line_price);
              var unit = row.querySelector('.unit');
              if (unit) {
                if (line.quantity > 1) {
                  unit.style.display = '';
                  unit.textContent = fmtMoney(line.final_price) + ' per stuk';
                } else {
                  unit.style.display = 'none';
                }
              }
            }
          }
          // Update header cart count if present
          var headerCt = document.querySelector('[data-cart-count]');
          if (headerCt) headerCt.textContent = cart.item_count;
        })
        .catch(function () { /* network errors fall back to native form submit on next interaction */ });
    }, 280);
  }

  // ---- PDP gallery: media slides (images + video) -----------
  function bkVideoMount(slide) {
    if (!slide || slide.classList.contains('is-playing')) return;
    var tmpl = slide.querySelector('[data-bk-video-template]');
    if (!tmpl) return;
    var wrap = document.createElement('div');
    wrap.className = 'bk-video-player';
    wrap.appendChild(tmpl.content.cloneNode(true));
    slide.appendChild(wrap);
    slide.classList.add('is-playing');
    var vid = wrap.querySelector('video');
    if (vid) { try { vid.play(); } catch (err) { /* autoplay may be blocked; controls remain */ } }
  }

  function bkVideoUnmount(slide) {
    if (!slide) return;
    var wrap = slide.querySelector('.bk-video-player');
    if (wrap) wrap.remove();
    slide.classList.remove('is-playing');
  }

  function bkGalleryShow(gallery, mediaId) {
    var main = gallery.querySelector('[data-bk-main]');
    var activeType = 'image';
    gallery.querySelectorAll('[data-bk-slide]').forEach(function (s) {
      var isActive = s.dataset.mediaId === mediaId;
      if (isActive) {
        s.hidden = false;
        s.classList.add('active');
        activeType = s.dataset.mediaType || 'image';
      } else {
        s.hidden = true;
        s.classList.remove('active');
        bkVideoUnmount(s);
      }
    });
    gallery.querySelectorAll('[data-bk-thumb]').forEach(function (t) {
      var on = t.dataset.mediaId === mediaId;
      t.classList.toggle('active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (main) main.classList.toggle('bk-main--video', activeType === 'video' || activeType === 'external_video');
  }

  // ---- Single delegated click handler -----------------------
  document.addEventListener('click', function (e) {
    // FAQ accordion
    var q = e.target.closest('.bk-acc-q, .bk-faq-item .q');
    if (q) {
      var item = q.closest('.bk-acc-item, .bk-faq-item');
      if (item) item.classList.toggle('open');
    }

    // FAQ category filter
    var faqCat = e.target.closest('.bk-faq-cat');
    if (faqCat) {
      var layout = faqCat.closest('.bk-faq-layout');
      layout.querySelectorAll('.bk-faq-cat').forEach(function (b) { b.classList.remove('active'); });
      faqCat.classList.add('active');
      var cat = faqCat.dataset.cat;
      layout.querySelectorAll('[data-faq-group]').forEach(function (g) {
        g.style.display = (!cat || cat === 'all' || g.dataset.faqGroup === cat) ? '' : 'none';
      });
    }

    // Cart drawer open/close
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      e.preventDefault();
      var drawer = document.querySelector('[data-bk-cart-drawer]');
      var backdrop = document.querySelector('.bk-drawer-backdrop');
      if (drawer) {
        drawer.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('bk-drawer-open');
      }
      if (backdrop) backdrop.classList.add('open');
      renderCartDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('bk-drawer-backdrop')) {
      var d2 = document.querySelector('[data-bk-cart-drawer]');
      var b2 = document.querySelector('.bk-drawer-backdrop');
      if (d2) { d2.classList.remove('open'); d2.setAttribute('aria-hidden', 'true'); }
      if (b2) b2.classList.remove('open');
      document.body.classList.remove('bk-drawer-open');
    }

    // PDP tab click — also handle in-page links that target a tab pane
    var jumpTab = e.target.closest('[data-bk-jump-tab]');
    if (jumpTab) {
      var tabsRoot = document.querySelector('[data-bk-tabs]');
      activateTab(tabsRoot, jumpTab.dataset.bkJumpTab);
      // Let the anchor hash do the scrolling.
    }

    var tab = e.target.closest('.bk-pdp-tabs [role="tab"]');
    if (tab) {
      var tabsRoot2 = tab.closest('[data-bk-tabs]');
      activateTab(tabsRoot2, tab.dataset.tab);
    }

    // PDP qty
    var qtyBtn = e.target.closest('[data-qty-step]');
    if (qtyBtn) {
      var step = parseInt(qtyBtn.dataset.qtyStep, 10);
      var input = qtyBtn.parentElement.querySelector('input[name="quantity"]');
      if (input) {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
      }
    }

    // PDP variant option selection
    var opt = e.target.closest('.bk-pdp-variants .opt[data-value]');
    if (opt) {
      var group = opt.closest('.opts');
      group.querySelectorAll('.opt').forEach(function (o) {
        o.classList.remove('on');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('on');
      opt.setAttribute('aria-checked', 'true');
      var form = opt.closest('[data-bk-product-form]');
      if (form) {
        var variant = resolveVariant(form);
        updateFormForVariant(form, variant);
        // Switch the gallery to the variant's own image, if it has one
        if (variant && variant.featured_media && variant.featured_media.id) {
          var pdpGallery = form.closest('.bk-pdp');
          pdpGallery = pdpGallery && pdpGallery.querySelector('[data-bk-gallery]');
          if (pdpGallery) bkGalleryShow(pdpGallery, String(variant.featured_media.id));
        }
      }
    }

    // PDP wishlist toggle
    var wish = e.target.closest('[data-bk-wish]');
    if (wish) {
      var pressed = wish.getAttribute('aria-pressed') === 'true';
      wish.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      wish.setAttribute('aria-label', pressed ? 'Toevoegen aan verlanglijst' : 'Verwijderen uit verlanglijst');
    }

    // Cart: quantity step
    var cartStep = e.target.closest('[data-bk-cart-step]');
    if (cartStep) {
      var stepDir = parseInt(cartStep.dataset.bkCartStep, 10);
      var key = cartStep.dataset.key;
      var row = cartStep.closest('.bk-cart-row');
      var inp = row && row.querySelector('[data-bk-cart-qty]');
      if (inp) {
        var newQ = Math.max(0, (parseInt(inp.value, 10) || 0) + stepDir);
        inp.value = newQ;
        updateCartLine(key, newQ, row);
      }
    }

    // Cart: remove row
    var cartRemove = e.target.closest('[data-bk-cart-remove]');
    if (cartRemove) {
      var rkey = cartRemove.dataset.key;
      var rrow = cartRemove.closest('.bk-cart-row');
      if (rrow) {
        rrow.classList.add('removing');
        updateCartLine(rkey, 0, rrow);
      }
    }

    // PDP gallery: play button on a video slide
    var vplay = e.target.closest('[data-bk-video-play]');
    if (vplay) {
      bkVideoMount(vplay.closest('[data-bk-slide]'));
      return;
    }

    // PDP gallery thumb → switch active media slide
    var thumb = e.target.closest('[data-bk-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-bk-gallery]');
      if (gallery) {
        var mid = thumb.dataset.mediaId;
        bkGalleryShow(gallery, mid);
        var slide = gallery.querySelector('[data-bk-slide][data-media-id="' + mid + '"]');
        if (slide && (slide.dataset.mediaType === 'video' || slide.dataset.mediaType === 'external_video')) {
          bkVideoMount(slide);
        }
      }
    }
  });

  // ---- Cart: qty input debounce on direct typing ------------
  document.addEventListener('change', function (e) {
    var qtyIn = e.target.closest('[data-bk-cart-qty]');
    if (!qtyIn) return;
    var key = qtyIn.dataset.key;
    var v = Math.max(0, parseInt(qtyIn.value, 10) || 0);
    qtyIn.value = v;
    var row = qtyIn.closest('.bk-cart-row');
    updateCartLine(key, v, row);
  });

  // ---- Tab keyboard navigation (arrow keys, home/end) -------
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('.bk-pdp-tabs [role="tab"]');
    if (!tab) return;
    var tabsRoot = tab.closest('[data-bk-tabs]');
    if (!tabsRoot) return;
    var tabs = Array.prototype.slice.call(tabsRoot.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab);
    var nextIdx = null;
    if (e.key === 'ArrowRight') nextIdx = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') nextIdx = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') nextIdx = 0;
    else if (e.key === 'End') nextIdx = tabs.length - 1;
    if (nextIdx !== null) {
      e.preventDefault();
      var nextTab = tabs[nextIdx];
      activateTab(tabsRoot, nextTab.dataset.tab);
      nextTab.focus();
    }
  });

  // ---- PDP form submit: intercept, add via fetch, open drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bk-product-form]');
    if (!form) return;
    e.preventDefault();
    var addBtn = form.querySelector('[data-bk-add]');
    var label = form.querySelector('[data-bk-add-label]');
    var origText = label ? label.textContent : '';
    if (addBtn) {
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.disabled = true;
    }
    if (label) label.textContent = 'Bezig…';
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, body: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        if (label) label.textContent = '✓ Toegevoegd';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var ct = document.querySelector('[data-cart-count]');
        if (ct && cart) {
          ct.textContent = cart.item_count;
          ct.style.display = cart.item_count > 0 ? '' : 'none';
        }
        openCartDrawer();
        setTimeout(function () {
          if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.disabled = false; }
          if (label) label.textContent = origText;
        }, 1400);
      })
      .catch(function () {
        // Fall back to a normal navigate
        if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.disabled = false; }
        if (label) label.textContent = origText;
        form.removeEventListener('submit', arguments.callee);
        form.submit();
      });
  });

  // ---- On load: activate tab from URL hash ------------------
  function activateTabFromHash() {
    var hash = window.location.hash;
    if (!hash) return;
    var tabsRoot = document.querySelector('[data-bk-tabs]');
    if (!tabsRoot) return;
    if (hash === '#reviews' || hash === '#bk-pane-rev') activateTab(tabsRoot, 'rev');
    else if (hash === '#bk-pane-spec') activateTab(tabsRoot, 'spec');
    else if (hash === '#bk-pane-desc') activateTab(tabsRoot, 'desc');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activateTabFromHash);
  } else {
    activateTabFromHash();
  }
  window.addEventListener('hashchange', activateTabFromHash);

  // ---- Mobile filter drawer ---------------------------------
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bk-filter-toggle]')) {
      var panel = document.querySelector('[data-bk-filters-panel]');
      var toggle = document.querySelector('[data-bk-filter-toggle]');
      if (!panel) return;
      var open = panel.classList.toggle('open');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('bk-filter-drawer-open', open);
    }
    if (e.target.closest('[data-bk-filter-close]') || e.target.classList.contains('bk-filter-backdrop')) {
      var panel2 = document.querySelector('[data-bk-filters-panel]');
      var toggle2 = document.querySelector('[data-bk-filter-toggle]');
      if (panel2) panel2.classList.remove('open');
      if (toggle2) toggle2.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bk-filter-drawer-open');
    }
  });

  // ---- Cart drawer renderer ---------------------------------
  function renderCartDrawer() {
    var body = document.querySelector('[data-bk-drawer-body]');
    var foot = document.querySelector('[data-bk-drawer-foot]');
    if (!body) return;
    body.innerHTML = '<div class="bk-drawer-loading">Bezig met laden…</div>';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          body.innerHTML = '<div class="bk-drawer-empty"><p>Uw mandje is leeg.</p><a href="/collections" class="bk-btn bk-btn--coral">Bekijk collecties</a></div>';
          if (foot) foot.hidden = true;
          return;
        }
        var html = '<ul class="bk-drawer-items">';
        cart.items.forEach(function (item) {
          html += '<li class="bk-drawer-row">'
            + '<a href="' + item.url + '" class="thumb">'
            + (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x200$1$2') + '" alt="" loading="lazy">' : '')
            + '</a>'
            + '<div class="info">'
            + '<div class="brand">' + escapeHtmlSafe(item.product_title) + '</div>'
            + (item.product_has_only_default_variant ? '' : '<div class="variant">' + escapeHtmlSafe(item.variant_title || '') + '</div>')
            + '<div class="qty-row">'
            + '<div class="qty"><button type="button" data-bk-drawer-step="-1" data-key="' + item.key + '" aria-label="Verlaag aantal">−</button>'
            + '<span>' + item.quantity + '</span>'
            + '<button type="button" data-bk-drawer-step="1" data-key="' + item.key + '" aria-label="Verhoog aantal">+</button></div>'
            + '<button type="button" class="rm" data-bk-drawer-remove data-key="' + item.key + '" aria-label="Verwijderen">Verwijderen</button>'
            + '</div>'
            + '</div>'
            + '<div class="price">' + formatMoneyDrawer(item.final_line_price) + '</div>'
            + '</li>';
        });
        html += '</ul>';
        body.innerHTML = html;
        if (foot) {
          foot.hidden = false;
          var sub = foot.querySelector('[data-bk-drawer-subtotal]');
          if (sub) sub.textContent = formatMoneyDrawer(cart.items_subtotal_price);
        }
      })
      .catch(function () {
        body.innerHTML = '<div class="bk-drawer-empty"><p>Even niet gelukt. <a href="/cart">Open winkelmandje</a></p></div>';
      });
  }
  function escapeHtmlSafe(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
  }
  function formatMoneyDrawer(cents) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }
  // Drawer qty steps + remove
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-bk-drawer-step]');
    if (step) {
      var dir = parseInt(step.dataset.bkDrawerStep, 10);
      var key = step.dataset.key;
      // Read current cart quantity for this key
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === key; });
        if (!line) return;
        var newQ = Math.max(0, line.quantity + dir);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQ })
        }).then(function () { renderCartDrawer(); syncHeaderCartCount(); });
      });
    }
    var rm = e.target.closest('[data-bk-drawer-remove]');
    if (rm) {
      var rkey = rm.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rkey, quantity: 0 })
      }).then(function () { renderCartDrawer(); syncHeaderCartCount(); });
    }
  });
  function syncHeaderCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var ct = document.querySelector('[data-cart-count]');
      if (ct) {
        ct.textContent = cart.item_count;
        ct.style.display = cart.item_count > 0 ? '' : 'none';
      }
    });
  }

  // ---- Predictive search ------------------------------------
  (function initPredictiveSearch() {
    var input = document.querySelector('[data-bk-search-input]');
    var suggest = document.querySelector('[data-bk-search-suggest]');
    if (!input || !suggest) return;
    var debounceT = null;
    function close() {
      suggest.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
    function open() {
      suggest.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounceT) clearTimeout(debounceT);
      if (q.length < 2) { close(); suggest.innerHTML = ''; return; }
      debounceT = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              suggest.innerHTML = '<div class="bk-search-suggest-empty">Geen suggesties voor &ldquo;' + escapeHtml(q) + '&rdquo;.</div>';
              open();
              return;
            }
            var html = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url || p.featured_image : (p.image || '');
              var price = p.price ? formatPrice(p.price) : '';
              return '<a class="bk-search-suggest-item" role="option" href="' + escapeAttr(p.url) + '">'
                + (img ? '<span class="thumb"><img src="' + escapeAttr(img.replace(/(\.[a-z]+)(\?|$)/, '_80x80$1$2')) + '" alt="" loading="lazy"></span>' : '<span class="thumb"></span>')
                + '<span class="info">'
                + '<span class="vendor">' + escapeHtml(p.vendor || '') + '</span>'
                + '<span class="title">' + escapeHtml(p.title) + '</span>'
                + '<span class="price">' + price + '</span>'
                + '</span></a>';
            }).join('');
            html += '<a class="bk-search-suggest-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Alle resultaten voor &ldquo;' + escapeHtml(q) + '&rdquo; →</a>';
            suggest.innerHTML = html;
            open();
          })
          .catch(function () { close(); });
      }, 200);
    });
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
    function escapeAttr(s) { return escapeHtml(s); }
    function formatPrice(cents) {
      if (typeof cents === 'string' && cents.indexOf('€') !== -1) return cents;
      var n = typeof cents === 'number' ? cents : parseFloat(cents) * 100;
      return '€' + (n / 100).toFixed(2).replace('.', ',');
    }
    document.addEventListener('click', function (e) {
      if (!suggest.contains(e.target) && e.target !== input) close();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });
  })();

  // ---- Sticky header on scroll ------------------------------
  var lastScrollY = 0;
  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    if (y > 240) document.body.classList.add('bk-scrolled');
    else document.body.classList.remove('bk-scrolled');
    lastScrollY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // ---- Recently viewed products ------------------------------
  var RV_KEY = 'bk-recently-viewed';
  var RV_LIMIT = 8;
  function trackRecentlyViewed() {
    var meta = document.querySelector('[data-bk-pdp-meta]');
    if (!meta) return;
    var handle = meta.dataset.productHandle;
    if (!handle) return;
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, RV_LIMIT);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ }
  }
  function renderRecentlyViewed() {
    var container = document.querySelector('[data-bk-recently-viewed]');
    if (!container) return;
    var currentHandle = (document.querySelector('[data-bk-pdp-meta]') || {}).dataset && document.querySelector('[data-bk-pdp-meta]').dataset.productHandle;
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 6);
    if (list.length === 0) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    var grid = container.querySelector('.bk-grid');
    if (!grid) return;
    grid.innerHTML = list.map(function () { return '<div class="bk-product-card-skeleton" aria-hidden="true"></div>'; }).join('');
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var cards = results.filter(Boolean).map(function (r) {
        var p = r.product;
        if (!p) return '';
        var v = p.variants && p.variants[0];
        var price = v ? '€' + (parseFloat(v.price)).toFixed(2).replace('.', ',') : '';
        var img = (p.images && p.images[0]) ? p.images[0].src : '';
        return '<a class="bk-product-card" href="/products/' + p.handle + '">'
          + '<div class="ph">'
          + (img ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/, '_480x480$1$2') + '" alt="" loading="lazy" width="480" height="480" style="width:100%;height:100%;object-fit:cover;position:absolute;inset:0;">' : '')
          + '</div>'
          + '<div class="body">'
          + '<div class="brand">' + (p.vendor || '') + '</div>'
          + '<div class="title">' + p.title + '</div>'
          + '<div class="price">' + price + '</div>'
          + '</div></a>';
      });
      if (cards.length === 0) { container.style.display = 'none'; return; }
      grid.innerHTML = cards.join('');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { trackRecentlyViewed(); renderRecentlyViewed(); });
  } else {
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  // ---- Wishlist persistence via localStorage ----------------
  var WISH_KEY = 'bk-wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ }
  }
  function syncWishUI() {
    var list = readWish();
    document.querySelectorAll('[data-bk-wish-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.productId) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-label', on ? 'Verwijderen uit verlanglijst' : 'Toevoegen aan verlanglijst');
    });
  }
  document.addEventListener('click', function (e) {
    var wish = e.target.closest('[data-bk-wish-toggle]');
    if (!wish) return;
    var id = wish.dataset.productId;
    var list = readWish();
    var i = list.indexOf(id);
    if (i === -1) { list.push(id); } else { list.splice(i, 1); }
    writeWish(list);
    syncWishUI();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWishUI);
  } else {
    syncWishUI();
  }

  // ---- Product card: quick-add to cart ----------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bk-quick-add]');
    if (!btn || btn.disabled) return;
    var id = btn.dataset.variantId;
    var label = btn.querySelector('[data-bk-quick-add-label]');
    var origText = label ? label.textContent : '';
    if (label) label.textContent = 'Bezig…';
    btn.classList.add('busy');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, body: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        if (label) label.textContent = '✓ Toegevoegd';
        btn.classList.remove('busy');
        btn.classList.add('done');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var ct = document.querySelector('[data-cart-count], .bk-iconbtn .cart-count');
        if (ct && cart) {
          ct.textContent = cart.item_count;
          ct.style.display = cart.item_count > 0 ? '' : 'none';
        }
        // Open cart drawer to show the just-added item
        openCartDrawer();
        setTimeout(function () {
          if (label) label.textContent = origText;
          btn.classList.remove('done');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        var url = btn.dataset.productUrl;
        if (url) window.location.href = url;
        else {
          if (label) label.textContent = origText;
          btn.disabled = false;
          btn.classList.remove('busy');
        }
      });
  });

  function openCartDrawer() {
    var drawer = document.querySelector('[data-bk-cart-drawer]');
    var backdrop = document.querySelector('.bk-drawer-backdrop');
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('open');
    document.body.classList.add('bk-drawer-open');
    renderCartDrawer();
  }

  // ---- PDP: sticky mobile add-to-cart bar -------------------
  function initPdpStickyBar() {
    var bar = document.querySelector('[data-bk-pdp-stickybar]');
    var buybox = document.querySelector('.bk-pdp .buybox');
    if (!bar || !buybox) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var hide = entry.isIntersecting;
        bar.classList.toggle('show', !hide);
        bar.setAttribute('aria-hidden', hide ? 'true' : 'false');
      });
    }, { rootMargin: '-80px 0px 0px 0px', threshold: 0 });
    io.observe(buybox);

    // Sticky add button triggers the real PDP form submit
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-bk-pdp-sticky-add]')) return;
      e.preventDefault();
      var form = document.querySelector('[data-bk-product-form]');
      if (!form) return;
      // Scroll to buybox first if user can see it being added
      buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Then submit the form
      setTimeout(function () {
        var submitBtn = form.querySelector('[data-bk-add]');
        if (submitBtn && !submitBtn.disabled) submitBtn.click();
      }, 240);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpStickyBar);
  } else {
    initPdpStickyBar();
  }

  // Reviews section: entrance reveal + score count-up. Motion users only; otherwise the
  // section renders fully static (CSS marquee + server-rendered score) with no JS dependency.
  function initReviews() {
    var el = document.querySelector('[data-reviews]');
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    el.classList.add('reveal-ready');
    var num = el.querySelector('[data-countup]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        el.classList.add('is-in');
        if (num) {
          var target = parseFloat((num.getAttribute('data-countup') || '').replace(',', '.')) || 0;
          var dur = 1100, start = null;
          num.textContent = '0,0';
          requestAnimationFrame(function tick(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 4);
            num.textContent = (target * eased).toFixed(1).replace('.', ',');
            if (p < 1) requestAnimationFrame(tick);
            else num.textContent = target.toFixed(1).replace('.', ',');
          });
        }
        io.disconnect();
      });
    }, { threshold: 0.35 });
    io.observe(el);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviews);
  } else {
    initReviews();
  }
})();
